;(function($) {

    $(document).on('click', '.accordion-block__toggle', function(e) {
        e.preventDefault();

        var $toggle = $(this);
        var $block = $toggle.closest('.accordion-block');
        var isOpen = $block.hasClass('is-open');

        $block.toggleClass('is-open', !isOpen);
        $toggle.attr('aria-expanded', String(!isOpen));
    });

})(jQuery);
